export const sendMessage2ServiceWorker = (...data) => {
    return navigator.serviceWorker?.controller?.postMessage?.(...data);
};

export default {};
